import { getMonthToDateRange } from '@/utils/date';
import {
  parseActiveStatusFilter,
  parseNumberFilter,
  parseTextFilter,
  toActiveStatusFilterText,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
  toPeriodFilterValues,
  toPeriodSearch,
} from '@/utils/filters';
import type {
  CatalogueStatus,
  PromoAdjustmentSearch,
  PromoDrillParams,
  PromoItemSearch,
} from '../types/promotion.types';

type FilterValues = Record<string, string>;

type PromoCatalogueFilterSearch = Pick<PromoItemSearch, 'activeState' | 'itemTypeId'>;

type PromoAdjustmentFilterSearch = Pick<
  PromoAdjustmentSearch,
  | 'dateFrom'
  | 'dateTo'
  | 'userId'
  | 'divisionId'
  | 'districtId'
  | 'thanaId'
  | 'itemTypeId'
  | 'itemCode'
>;

function toActiveState(isActive: boolean | undefined): CatalogueStatus {
  if (isActive === undefined) return 'all';
  return isActive ? 'active' : 'inactive';
}

function toIsActive(activeState: CatalogueStatus): boolean | undefined {
  return activeState === 'all' ? undefined : activeState === 'active';
}

export function toPromoCatalogueFilterValues(search: PromoCatalogueFilterSearch): FilterValues {
  return {
    isActive: toActiveStatusFilterText(toIsActive(search.activeState)),
    itemTypeId: toFilterText(search.itemTypeId),
  };
}

export function toPromoCatalogueFilterSearch(values: FilterValues): PromoCatalogueFilterSearch {
  return {
    activeState: toActiveState(parseActiveStatusFilter(values.isActive)),
    itemTypeId: parseNumberFilter(values.itemTypeId),
  };
}

export function toPromoAdjustmentFilterValues(search: PromoAdjustmentFilterSearch): FilterValues {
  return {
    ...toPeriodFilterValues(search, getMonthToDateRange()),
    userId: toFilterText(search.userId),
    ...toGeoFilterValues(search),
    itemTypeId: toFilterText(search.itemTypeId),
    itemCode: toFilterText(search.itemCode),
  };
}

export function toPromoAdjustmentFilterSearch(values: FilterValues): PromoAdjustmentFilterSearch {
  return {
    ...toPeriodSearch(values),
    userId: parseNumberFilter(values.userId),
    ...toGeoSearch(values),
    itemTypeId: parseNumberFilter(values.itemTypeId),
    itemCode: parseTextFilter(values.itemCode),
  };
}

export function toPromoZmSearch(listParams: PromoDrillParams): PromoDrillParams {
  return {
    dateFrom: listParams.dateFrom,
    dateTo: listParams.dateTo,
    divisionId: listParams.divisionId,
    districtId: listParams.districtId,
    thanaId: listParams.thanaId,
  };
}
